// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".navbar-drawer--dark[data-v-3ed74473] {\n  background-color: var(--gray-100) !important;\n  max-height: calc(100vh - 50px);\n  top: 50px !important;\n}\n.navbar-drawer--dark span[data-v-3ed74473] {\n  color: #98999d;\n}", ""]);
// Exports
module.exports = exports;
